import React from "react";
import { Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

interface Props {
  children?: React.ReactNode;
  customText: string;
  color?: string;
}

const HelpPopOver: React.FC<Props> = ({ children, customText, color }) => {
  return (
    <Popover
      content={customText}
      title={null}
      trigger="hover"
      placement="top"
      styles={{ body: { maxWidth: "200px" } }}
    >
      {children ? (
        <div>{children}</div>
      ) : (
        <InfoCircleOutlined size={19} color={color} />
      )}
    </Popover>
  );
};

export default HelpPopOver;
